/* eslint-disable no-param-reassign */
/* eslint-disable no-underscore-dangle */
import { call, put, select, takeLatest } from 'redux-saga/effects';

import SDK from 'utils/sdk';
import { SubmissionError } from 'redux-form';
import { messageError } from 'views/ui/toast-message';
import { getLocationItems } from './selector';
import { locationList, locationRetrieve } from './actions';

export function* locationListSaga() {
  try {
    yield put(locationList.request());

    const client = yield call([SDK, 'getClient']);
    const { data } = yield call([client, 'locationList'], {});
    yield put(locationList.success(data));
  } catch (error) {
    const data = error?.response?.data?.message?.toString();
    yield put(locationList.failure(new SubmissionError({ _error: data })));
    messageError(data);
  } finally {
    yield put(locationList.fulfill());
  }
}

export function* locationRetrieveSaga({ payload: { id } }) {
  try {
    yield put(locationRetrieve.request());

    const locationItems = yield select(getLocationItems);

    let locationItem = null;
    if (locationItems === []) {
      const client = yield call([SDK, 'getClient']);
      const { data } = yield call([client, 'locationOne'], { id });

      locationItem = data;
    } else {
      locationItem = locationItems.find(
        (reduxStoreLocationItem) => reduxStoreLocationItem._id === id
      );
    }

    yield put(locationRetrieve.success(locationItem));
  } catch (error) {
    const data = error?.response?.data?.message?.toString();
    yield put(locationRetrieve.failure(new SubmissionError({ _error: data })));
    messageError(data);
  } finally {
    yield put(locationRetrieve.fulfill());
  }
}

export default function* LocationsWatch() {
  yield takeLatest(locationList.TRIGGER, locationListSaga);
  yield takeLatest(locationRetrieve.TRIGGER, locationRetrieveSaga);
}
